import { HOST } from "../constants/HostConstants";

export const advertisementAdminUpdate = async (
  advertisement_id,
  advertisement_url,
  link_url,
) => {
  try {
    const response = await fetch(`${HOST}/api/advertisement/adminUpdate`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ advertisement_id, advertisement_url, link_url }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || "Failed to update advertisement");
    }

    return await response.json();
  } catch (error) {
    console.error("Error updating ad:", error);
    throw error;
  }
};
